import React, { ChangeEvent } from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { RadioButton } from 'src/components/atoms/RadioButton/components/RadioButton';

type RadioButtonData = {
  labelText: string;
  value: string;
};

export interface RadioButtonGroupProps {
  accessibleLabel: string;
  accessibleLabelElementType?: keyof JSX.IntrinsicElements;
  accessibleLabelElementId?: string;
  name: string;
  hideLabel?: boolean;
  value?: string;
  onChange: (value: string, event: ChangeEvent<HTMLInputElement>) => void;
  radioButtonData: RadioButtonData[];
}

/**
 * The accessibleLabelElementType prop should be a string which represents the type of HTML element to use for the label e.g. 'h1'.
 * The accessibleLabelElementId prop should contain a string to customise the id attribute for the label element containing the accessible label.
 */
export const RadioButtonGroup = ({
  name,
  accessibleLabel,
  accessibleLabelElementType: AccessibleLabelElementTag = 'p',
  accessibleLabelElementId = `${name}-label`,
  hideLabel = false,
  value,
  onChange,
  radioButtonData,
}: RadioButtonGroupProps) => (
  <div role="group" aria-labelledby={accessibleLabelElementId}>
    <span id={accessibleLabelElementId} css={hideLabel ? visuallyHidden : undefined}>
      <AccessibleLabelElementTag>{accessibleLabel}</AccessibleLabelElementTag>
    </span>
    {radioButtonData.map(({ labelText, value: radioButtonValue }) => (
      <RadioButton
        name={name}
        labelText={labelText}
        value={radioButtonValue}
        key={radioButtonValue}
        checked={radioButtonValue === value}
        onChange={(e) => onChange(radioButtonValue, e)}
      />
    ))}
  </div>
);
